import {types} from '../Types/type'

export const setLanguage = (lang) =>({
    type: types.ChangeLanguage,
    payload: lang
})


export const setToggleNavbar = (setState) =>({
    type: types.showSidebar,
    payload: setState
})